<div class="locations-container">
  <!-- Fleet Selector -->
  <div class="row mb-4">
    <div class="col-md-6">
      <app-fleet-selector (fleetSelected)="onFleetSelected($event)"></app-fleet-selector>
    </div>
    <div *ngIf="selectedFleet" class="col-md-6">
      <app-fleet-health [selectedFleet]="selectedFleet" (indicatorClicked)="onAlertsSummaryIndicatorClicked($event)"></app-fleet-health>
    </div>
  </div>

  <!-- Alert for no fleet selected -->
  <div *ngIf="!selectedFleet" class="alert alert-info">Please select a fleet to view locations.</div>

  <div *ngIf="loading" class="alert alert-info">Loading.</div>

  <!-- Locations content when fleet is selected -->
  <div *ngIf="selectedFleet">
    <div class="card">
      <div class="card-header bg-light">
        <div class="row align-items-center">
          <div class="col-md-6">
            <h5 class="mb-0">
              Fleet: <strong>{{ selectedFleet.id }}</strong>
            </h5>
            <p *ngIf="numRows === 0 && !updatingData" class="mb-0">0 locations</p>
            <p *ngIf="numRows === 1 && !updatingData" class="mb-0">1 location</p>
            <p *ngIf="numRows > 1 && !updatingData" class="mb-0">{{ numRows }} locations</p>
            <p *ngIf="updatingData" class="mb-0">&nbsp;</p>
          </div>
          <div class="col-md-6">
            <div class="input-group" style="justify-content: flex-end">
              <button *ngIf="isFiltered" class="btn btn-outline-primary" type="button" (click)="clearAllFilters()">Clear All Filters</button>
              <button class="btn btn-outline-primary" type="button" (click)="openAddLocationModal()">Add Location</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Add Location Component -->
      <app-add-location [selectedFleet]="selectedFleet" (locationAdded)="onSearch()"></app-add-location>

      <!-- Move Hub Component -->
      <app-move-hub (hubMoved)="onSearch()"></app-move-hub>

      <!-- Change Fleet Component -->
      <app-change-fleet (fleetChanged)="onSearch()"></app-change-fleet>

      <!-- Add User Component -->
      <app-add-user [selectedLocation]="selectedLocation" (userAdded)="onSearch()"></app-add-user>

      <div class="card-body">
        <!-- Loading indicator -->
        <div *ngIf="loading" class="text-center p-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Loading locations...</p>
        </div>

        <!-- Error message -->
        <div *ngIf="error" class="alert alert-danger">
          {{ error }}
        </div>

        <!-- No results message -->
        <div *ngIf="!updatingData && !loading && !error && numRows === 0" class="alert alert-warning">
          No locations found. {{ searchTerm ? 'Try a different search term.' : '' }}
        </div>

        <!-- AG Grid -->
        <div *ngIf="!loading && !error" class="ag-theme-alpine" style="height: 500px; width: 100%">
          <ag-grid-angular
            class="ag-theme-alpine"
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)"
            (modelUpdated)="onModelUpdated($event)"
            style="width: 100%; height: 500px"
          >
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedFleet">
    <!-- Hub Configuration -->
    <div *ngIf="!loading && !error && selectedLocation">
      <app-location-plots [locationId]="selectedLocation?.uuid" [selectedLocation]="selectedLocation"></app-location-plots>
    </div>

    <div *ngIf="!loading && !error && selectedLocation" class="card mt-4" data-cy="location-detail-card">
      <div id="locationDetailHeader" class="card-header bg-light" data-cy="location-detail-header">
        <div class="row align-items-center">
          <div class="col-md-6">
            <h5 class="mb-0">
              Location: <strong>{{ selectedLocation!.label }}</strong>
              <svg
                *ngIf="(selectedLocation?.alerts ?? []).length > 0"
                width="24"
                height="24"
                style="margin-left: 10px"
                [attr.fill]="hasError(selectedLocation) ? 'red' : 'orange'"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 mt-2"
                >
                  <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96
                          0L.165 13.233c-.457.778.091 1.767.98
                          1.767h13.713c.889 0 1.438-.99.98-1.767L8.982
                          1.566zM8 5c.535 0 .954.462.9.995l-.35
                          3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905
                          0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <span
                *ngIf="getLocationMutingStatus() as mutingStatus"
                data-cy="location-detail-status-tag"
                class="location-muting-badge"
                [class.location-muting-badge-partial]="mutingStatus === 'Partially Muted'"
              >
                {{ mutingStatus }}
              </span>
            </h5>
          </div>
          <div class="col-md-6">
            <div class="input-group" style="justify-content: flex-end">
              <button (click)="onAddUserButtonClick()" class="btn btn-outline-primary">Add User to this location</button>
              <button (click)="onChangeFleetButtonClick()" class="btn btn-outline-primary">Change the Fleet of this location</button>
              <button (click)="onMoveHubButtonClick()" class="btn btn-outline-primary">Move a Hub to this location</button>
            </div>
          </div>
        </div>
      </div>


      <div id="locationDetailBody" *ngIf="!loading && !error && selectedLocation" class="card-body">
        <!-- Loading indicator -->
        <div *ngIf="loading" class="text-center p-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Loading location detail...</p>
        </div>

        <!-- Error message -->
        <div *ngIf="error" class="alert alert-danger">
          {{ error }}
        </div>

        <!-- No selected location message -->
        <div *ngIf="!loading && !error && !selectedLocation" class="alert alert-info">Click on a location in the grid above to view its details.</div>

        <!-- Location details -->
        <div *ngIf="!loading && !error && selectedLocation" class="location-details">
          <div class="row">
            <div class="col-md-6">
              <p><strong>Address:</strong> {{ selectedLocation!.address }}</p>
              <p><strong>City:</strong> {{ selectedLocation!.city }}</p>
              <p><strong>State:</strong> {{ selectedLocation!.state }}</p>
              <p><strong>Postal Code:</strong> {{ selectedLocation!.postcode }}</p>
              <p><strong>Country:</strong> {{ selectedLocation!.country }}</p>
              <p><strong>Timezone:</strong> {{ selectedLocation!.timezone }}</p>
            </div>
            <div class="col-md-6">
              <!--              <p><strong>Location UUID:</strong> {{ selectedLocation!.uuid }}</p>-->
              <p><strong>Users:</strong></p>
              <ul *ngIf="selectedLocation && selectedLocation.users && selectedLocation.users.length > 0" class="list-group">
                <li *ngFor="let user of selectedLocation!.users" class="list-group-item d-flex justify-content-between align-items-center">
                  {{ user.email_address }}
                </li>
              </ul>
              <p *ngIf="!selectedLocation!.users?.length">No users found</p>
              <p></p>
              <p><strong>Hubs assigned to this location:</strong></p>
              <ul *ngIf="selectedLocation && selectedLocation.hubs && selectedLocation.hubs.length > 0" class="list-group">
                <li *ngFor="let hub of selectedLocation!.hubs" class="list-group-item d-flex justify-content-between align-items-center">
                  <div><strong>Hub ID:</strong> {{ hub.id }}</div>
                  <div>
                    <button (click)="onConfigHubButtonClick(hub.id)" class="btn btn-primary me-2">View/Configure {{ hub.id }}</button>
                    <button (click)="onConfigHubWebButtonClick(hub.id)" class="btn btn-secondary me-2">Configure (via web app) {{ hub.id }}</button>
                  </div>
                </li>
              </ul>
              <p *ngIf="!selectedLocation!.hubs?.length">No hubs found</p>
            </div>
          </div>
        </div>

        <hr />

        <div id="locationAlerts" *ngIf="!loading && !error && selectedLocation" class="location-details" data-cy="location-alerts-section">
          <div class="row">
            <div class="col-md-12" *ngIf="(selectedLocation?.alerts ?? []).length > 0">
              <div class="alerts-header-row">
                <p class="mb-0"><strong>Alerts:</strong></p>
                <div class="alerts-header-actions">
                  <ng-container *ngIf="isLocationWideMuted(); else muteAllAction">
                    <button
                      type="button"
                      data-cy="location-unmute-all-button"
                      class="btn btn-sm btn-outline-danger"
                      [disabled]="isMutatingAllAlerts"
                      (click)="onUnmuteAllAlerts()"
                    >
                      {{ isMutatingAllAlerts ? 'Saving...' : 'Unmute All' }}
                    </button>
                  </ng-container>
                  <ng-template #muteAllAction>
                    <div class="mute-dropdown" data-cy="location-mute-all-dropdown">
                      <button
                        type="button"
                        data-cy="location-mute-all-button"
                        class="btn btn-sm btn-outline-secondary dropdown-toggle"
                        [disabled]="isMutatingAllAlerts"
                        (click)="toggleLocationWideMuteDropdown()"
                      >
                        {{ isMutatingAllAlerts ? 'Saving...' : 'Mute All' }}
                      </button>
                      <div class="mute-dropdown-menu" *ngIf="isLocationWideMuteDropdownOpen" data-cy="location-mute-all-menu">
                        <button type="button" data-cy="location-mute-all-option-tomorrow" class="dropdown-item" (click)="onMuteAllForDuration(24 * 60 * 60 * 1000)">Until tomorrow</button>
                        <button type="button" data-cy="location-mute-all-option-2days" class="dropdown-item" (click)="onMuteAllForDuration(2 * 24 * 60 * 60 * 1000)">For 2 days</button>
                        <button type="button" data-cy="location-mute-all-option-week" class="dropdown-item" (click)="onMuteAllForDuration(7 * 24 * 60 * 60 * 1000)">For a week</button>
                        <button type="button" data-cy="location-mute-all-option-custom" class="dropdown-item" (click)="showCustomMuteAllDatePicker()">Custom date</button>
                        <div class="mute-custom-date" *ngIf="isCustomMuteAllVisible">
                          <input
                            type="datetime-local"
                            data-cy="location-mute-all-custom-date"
                            class="form-control form-control-sm"
                            [(ngModel)]="customMuteAllUntil"
                            [ngModelOptions]="{standalone: true}"
                          />
                          <button type="button" data-cy="location-mute-all-custom-apply" class="btn btn-sm btn-primary" (click)="onMuteAllUntilCustomDate()">Apply</button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <div class="form-check form-switch show-muted-toggle">
                    <input
                      id="showMutedAlerts"
                      data-cy="location-show-muted-toggle"
                      class="form-check-input"
                      type="checkbox"
                      [(ngModel)]="showMutedAlerts"
                      [ngModelOptions]="{standalone: true}"
                    />
                    <label class="form-check-label" for="showMutedAlerts">Show muted</label>
                  </div>
                </div>
              </div>
              <p *ngIf="(selectedLocation.alerts ?? [])[0]!.system_id">
                <a href="https://enlighten.enphaseenergy.com/systems/{{ (selectedLocation.alerts ?? [])[0]!.system_id }}" target="_blank"
                  >View in Enphase Portal</a
                >
              </p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocation?.alerts ?? []).length === 0">
            <div class="col-md-12">
              <p>No alerts in the last 24 hours</p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocation?.alerts ?? []).length > 0 && getVisibleAlerts().length === 0">
            <div class="col-md-12">
              <p>No unmuted alerts to show.</p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocation?.alerts ?? []).length > 0 && getVisibleAlerts().length > 0">
            <div class="col-md-12">
              <table id="locationAlertsList" data-cy="location-alerts-table" class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Timestamp</th>
                    <th>Type</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Mute</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let alert of getVisibleAlerts(); let i = index" [attr.data-cy]="'location-alert-row-' + getAlertTestKey(alert, i)">
                    <td style="white-space: nowrap">{{ alert.created_at | date : 'short' }}</td>
                    <td style="text-transform: capitalize">{{ alert.type }}</td>
                    <td style="white-space: nowrap">{{ alert.message_type }}</td>
                    <td style="white-space: pre-wrap">{{ alert.message }}</td>
                    <td class="alert-actions-cell">
                      <ng-container *ngIf="isAlertMuted(alert); else muteAction">
                        <button
                          type="button"
                          [attr.data-cy]="'location-alert-unmute-button-' + getAlertTestKey(alert, i)"
                          class="btn btn-sm btn-outline-danger"
                          [disabled]="isMutatingAlert(alert)"
                          (click)="onUnmuteAlert(alert)"
                        >
                          {{ isMutatingAlert(alert) ? 'Saving...' : 'Unmute' }}
                        </button>
                      </ng-container>
                      <ng-template #muteAction>
                        <div class="mute-dropdown" [attr.data-cy]="'location-alert-mute-dropdown-' + getAlertTestKey(alert, i)">
                          <button
                            type="button"
                            [attr.data-cy]="'location-alert-mute-button-' + getAlertTestKey(alert, i)"
                            class="btn btn-sm btn-outline-secondary dropdown-toggle"
                            [disabled]="isMutatingAlert(alert) || !canMuteAlert(alert)"
                            (click)="toggleMuteDropdown(alert)"
                          >
                            {{ isMutatingAlert(alert) ? 'Saving...' : 'Mute' }}
                          </button>
                          <div class="mute-dropdown-menu" *ngIf="isMuteDropdownOpen(alert)" [attr.data-cy]="'location-alert-mute-menu-' + getAlertTestKey(alert, i)">
                            <button type="button" [attr.data-cy]="'location-alert-mute-option-tomorrow-' + getAlertTestKey(alert, i)" class="dropdown-item" (click)="onMuteAlertForDuration(alert, 24 * 60 * 60 * 1000)">Until tomorrow</button>
                            <button type="button" [attr.data-cy]="'location-alert-mute-option-2days-' + getAlertTestKey(alert, i)" class="dropdown-item" (click)="onMuteAlertForDuration(alert, 2 * 24 * 60 * 60 * 1000)">For 2 days</button>
                            <button type="button" [attr.data-cy]="'location-alert-mute-option-week-' + getAlertTestKey(alert, i)" class="dropdown-item" (click)="onMuteAlertForDuration(alert, 7 * 24 * 60 * 60 * 1000)">For a week</button>
                            <button type="button" [attr.data-cy]="'location-alert-mute-option-custom-' + getAlertTestKey(alert, i)" class="dropdown-item" (click)="showCustomDatePicker(alert)">Custom date</button>
                            <div class="mute-custom-date" *ngIf="isCustomDatePickerVisible(alert)">
                              <input
                                type="datetime-local"
                                [attr.data-cy]="'location-alert-mute-custom-date-' + getAlertTestKey(alert, i)"
                                class="form-control form-control-sm"
                                [(ngModel)]="customMuteUntilByAlertKey[getAlertKey(alert)]"
                                [ngModelOptions]="{standalone: true}"
                              />
                              <button type="button" [attr.data-cy]="'location-alert-mute-custom-apply-' + getAlertTestKey(alert, i)" class="btn btn-sm btn-primary" (click)="onMuteAlertUntilCustomDate(alert)">Apply</button>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <hr />

        <div id="locationSFRPanel" *ngIf="!loading && !error && selectedLocationDetails" class="location-details">
          <div class="row">
            <div class="col-md-12">
              <p><strong>SFR Billing Info:</strong></p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocationDetails?.sfrData ?? []).length === 0">
            <div class="col-md-12">
              <p>No info</p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocationDetails?.sfrData ?? []).length > 0">
            <div class="col-md-12">
              <div
                class="row"
                *ngFor="let item of selectedLocationDetails?.sfrData ?? []; let i = index"
                [ngStyle]="{ 'margin-left': '8px', 'margin-right': '8px', padding: '8px', 'border-top': i > 0 ? '1px gray dashed' : 'none' }"
              >
                <div class="col-md-6">
                  <p><strong>Opportunity Name:</strong> {{ item.opportunity_name }}</p>
                  <p><strong>Property ID:</strong> {{ item.property_id }}</p>
                  <p><strong>Active:</strong> {{ item.active ? 'Yes' : 'No' }}</p>
                  <p><strong>Test:</strong> {{ item.test ? 'Yes' : 'No' }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Last Interval Delivered At:</strong> {{ item.ts_last_delivered_interval | date : 'short' }}</p>
                  <p><strong>Created At:</strong> {{ item.ts_created | date : 'short' }}</p>
                  <p><strong>Modified At:</strong> {{ item.ts_modified | date : 'short' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div id="locationProjectRecordPanel" *ngIf="!loading && !error && selectedLocationDetails" class="location-details">
          <div class="row">
            <div class="col-md-12">
              <p><strong>Netsuite Info:</strong></p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocationDetails?.projectRecordData ?? []).length === 0">
            <div class="col-md-12">
              <p>No info</p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocationDetails?.projectRecordData ?? []).length > 0">
            <div class="col-md-12">
              <div
                class="row"
                *ngFor="let item of selectedLocationDetails?.projectRecordData ?? []; let i = index"
                [ngStyle]="{ 'margin-left': '8px', 'margin-right': '8px', padding: '8px', 'border-top': i > 0 ? '1px gray dashed' : 'none' }"
              >
                <div class="col-md-6">
                  <p><strong>Project Class:</strong> {{ item.netsuite_project_class }}</p>
                  <p><strong>Project ID:</strong> {{ item.netsuite_project_id }}</p>
                  <p><strong>Community Name:</strong> {{ item.netsuite_community_name }}</p>
                  <p><strong>Project Name:</strong> {{ item.netsuite_project_name }}</p>
                  <p><strong>Installation Address:</strong> {{ item.netsuite_installation_address_1 }}</p>
                  <p><strong>Installation City:</strong> {{ item.netsuite_installation_city }}</p>
                  <p><strong>Installation State:</strong> {{ item.netsuite_installation_state }}</p>
                  <p><strong>Installation Postal Code:</strong> {{ item.netsuite_installation_zip_code }}</p>
                  <p><strong>SalesForce Opportunity ID:</strong> {{ item.netsuite_salesforce_opportunity_id }}</p>
                  <p><strong>Customer CRM ID:</strong> {{ item.netsuite_customer_crm_id }}</p>
                  <p><strong>Inverter Item:</strong> {{ item.netsuite_inverter_item }}</p>
                  <p><strong>Site ID:</strong> {{ item.netsuite_site_id }}</p>
                  <p><strong>Inverter Monitoring ID:</strong> {{ item.netsuite_inverter_monitoring_id }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Timezone:</strong> {{ item.timezone }}</p>
                  <p><strong>Internal ID:</strong> {{ item.netsuite_internal_id }}</p>
                  <p><strong>Project Class ID:</strong> {{ item.netsuite_project_class_id }}</p>
                  <p><strong>Billing:</strong> {{ item.is_billing ? 'Yes' : 'No' }}</p>
                  <p><strong>SFR Client Name:</strong> {{ item.netsuite_sfr_client_name }}</p>
                  <p><strong>Module Quantity:</strong> {{ item.netsuite_module_quantity_num }}</p>
                  <p><strong>Inverter Quandtity:</strong> {{ item.netsuite_inverter_quantity_num }}</p>
                  <p><strong>Test:</strong> {{ item.test ? 'Yes' : 'No' }}</p>
                  <p><strong>System ID:</strong> {{ item.system_id }}</p>
                  <p><strong>Mapping Test Reporting Complete:</strong> {{ item.netsuite_mapping_test_reporting_complete | date : 'short' }}</p>
                  <p><strong>Admin Act Grp End Date:</strong> {{ item.netsuite_admin_act_grp_end_date | date : 'short' }}</p>
                  <p><strong>Created At:</strong> {{ item.ts_created | date : 'short' }}</p>
                  <p><strong>Modified At:</strong> {{ item.ts_modified | date : 'short' }}</p>
                  <p><strong>Version:</strong> {{ item.version }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div id="locationDevicesPanel" *ngIf="!loading && !error && selectedLocationDetails" class="location-details">
          <div class="row">
            <div class="col-md-12">
              <p><strong>Devices Info:</strong></p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocationDetails?.devicesData ?? []).length === 0">
            <div class="col-md-12">
              <p>No info</p>
            </div>
          </div>
          <div class="row" *ngIf="(selectedLocationDetails?.devicesData ?? []).length > 0">
            <div class="col-md-12">
              <div
                class="row"
                *ngFor="let item of selectedLocationDetails?.devicesData ?? []; let i = index"
                [ngStyle]="{ 'margin-left': '8px', 'margin-right': '8px', padding: '8px', 'border-top': i > 0 ? '1px gray dashed' : 'none' }"
              >
                <div class="col-md-6">
                  <p><strong>Type:</strong> {{ item.device_type?.name }}</p>
                  <p><strong>Interval Durations:</strong> {{ item.device_type?.intervalDurations }}</p>
                  <p><strong>Created At:</strong> {{ item.ts_created | date : 'short' }}</p>
                  <p><strong>Modified At:</strong> {{ item.ts_modified | date : 'short' }}</p>
                  <p><strong>Version:</strong> {{ item.version }}</p>
                  <p><strong>Test:</strong> {{ item.test ? 'Yes' : 'No' }}</p>
                </div>
                <div *ngIf="item.device_type?.name === 'Enphase'" class="col-md-6">
                  <p><strong>Active:</strong> {{ item.enphase?.active ? 'Yes' : 'No' }}</p>
                  <p><strong>Activation Date:</strong> {{ item.enphase?.activation_date | date : 'short' }}</p>
                  <p><strong>Monitoring Complete Date:</strong> {{ item.enphase?.monitoring_complete_date | date : 'short' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div id="locationQualityControlPanel" *ngIf="!loading && !error && selectedLocationDetails" class="location-details">
          <div class="row">
            <div class="col-md-12">
              <p><strong>Quality Control Info:</strong></p>
            </div>
          </div>
          <div
            class="row"
            *ngIf="
              (selectedLocationDetails?.qcData?.['enphase-device'] ?? []).length === 0 &&
              (selectedLocationDetails?.qcData?.hub ?? []).length === 0 &&
              (selectedLocationDetails?.qcData?.location ?? []).length === 0
            "
          >
            <div class="col-md-12">
              <p>No info</p>
            </div>
          </div>

          <div class="row" *ngIf="(selectedLocationDetails?.qcData?.['enphase-device'] ?? []).length > 0">
            <div class="col-md-12">
              <div class="qc-section-header">
                <div class="qc-section-title">
                  <p class="mb-0"><strong>Enphase Device</strong></p>
                  <span class="qc-unconfirmed-alert" *ngIf="isLatestQcScanUnconfirmed(selectedLocationDetails?.qcData?.['enphase-device'])">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"></path>
                    </svg>
                    QC Scan not confirmed
                  </span>
                </div>
              </div>
              <table class="table table-striped table-bordered qc-table">
                <thead>
                  <tr>
                    <th class="qc-table-flex-column">System ID</th>
                    <th class="qc-table-fixed-column">Version</th>
                    <th class="qc-table-fixed-column">Scan Performed</th>
                    <th class="qc-table-fixed-column">Scan Date</th>
                    <th class="qc-table-fixed-column">Scan Error</th>
                    <th class="qc-table-fixed-column">Scan Confirmed</th>
                    <th class="qc-table-flex-column">Errors</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of selectedLocationDetails?.qcData?.['enphase-device'] ?? []">
                    <td class="qc-table-flex-column">{{ item.system_id }}</td>
                    <td class="qc-table-fixed-column">{{ item.version }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_performed ? 'Yes' : 'No' }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_date | date : 'short' }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_error ? 'Yes' : 'No' }}</td>
                    <td class="qc-table-fixed-column">
                      <div class="form-check form-switch qc-confirm-switch" *ngIf="shouldShowQcConfirmToggle(selectedLocationDetails?.qcData?.['enphase-device'], item); else enphaseScanConfirmedValue">
                        <span class="qc-confirm-switch-label">{{ isQcScanConfirmed(item) ? 'Yes' : 'No' }}</span>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="isQcScanConfirmed(item)"
                          (click)="openConfirmScanModal('Enphase Device', 'enphase-device', item, !isQcScanConfirmed(item)); $event.preventDefault()"
                        />
                      </div>
                      <ng-template #enphaseScanConfirmedValue>{{ isQcScanConfirmed(item) ? 'Yes' : 'No' }}</ng-template>
                    </td>
                    <td class="qc-table-flex-column qc-table-errors">
                      <ng-container *ngIf="(item.qc_scan_error_list ?? []).length > 0; else noEnphaseQcErrors">
                        <div *ngFor="let qcError of item.qc_scan_error_list">{{ qcError.type }} - {{ qcError.message }}</div>
                      </ng-container>
                      <ng-template #noEnphaseQcErrors>None</ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row" *ngIf="(selectedLocationDetails?.qcData?.hub ?? []).length > 0">
            <div class="col-md-12">
              <div class="qc-section-header">
                <div class="qc-section-title">
                  <p class="mb-0"><strong>Hub</strong></p>
                  <span class="qc-unconfirmed-alert" *ngIf="isLatestQcScanUnconfirmed(selectedLocationDetails?.qcData?.hub)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"></path>
                    </svg>
                    QC Scan not confirmed
                  </span>
                </div>
              </div>
              <table class="table table-striped table-bordered qc-table">
                <thead>
                  <tr>
                    <th class="qc-table-flex-column">Serial Number</th>
                    <th class="qc-table-fixed-column">Version</th>
                    <th class="qc-table-fixed-column">Scan Performed</th>
                    <th class="qc-table-fixed-column">Scan Date</th>
                    <th class="qc-table-fixed-column">Scan Error</th>
                    <th class="qc-table-fixed-column">Scan Confirmed</th>
                    <th class="qc-table-flex-column">Errors</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of selectedLocationDetails?.qcData?.hub ?? []">
                    <td class="qc-table-flex-column">{{ item.hub_serial_number }}</td>
                    <td class="qc-table-fixed-column">{{ item.version }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_performed ? 'Yes' : 'No' }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_date | date : 'short' }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_error ? 'Yes' : 'No' }}</td>
                    <td class="qc-table-fixed-column">
                      <div class="form-check form-switch qc-confirm-switch" *ngIf="shouldShowQcConfirmToggle(selectedLocationDetails?.qcData?.hub, item); else hubScanConfirmedValue">
                        <span class="qc-confirm-switch-label">{{ isQcScanConfirmed(item) ? 'Yes' : 'No' }}</span>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="isQcScanConfirmed(item)"
                          (click)="openConfirmScanModal('Hub', 'hub', item, !isQcScanConfirmed(item)); $event.preventDefault()"
                        />
                      </div>
                      <ng-template #hubScanConfirmedValue>{{ isQcScanConfirmed(item) ? 'Yes' : 'No' }}</ng-template>
                    </td>
                    <td class="qc-table-flex-column qc-table-errors">
                      <ng-container *ngIf="(item.qc_scan_error_list ?? []).length > 0; else noHubQcErrors">
                        <div *ngFor="let qcError of item.qc_scan_error_list">{{ qcError.type }} - {{ qcError.message }}</div>
                      </ng-container>
                      <ng-template #noHubQcErrors>None</ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row" *ngIf="(selectedLocationDetails?.qcData?.location ?? []).length > 0">
            <div class="col-md-12">
              <div class="qc-section-header">
                <div class="qc-section-title">
                  <p class="mb-0"><strong>Location</strong></p>
                  <span class="qc-unconfirmed-alert" *ngIf="isLatestQcScanUnconfirmed(selectedLocationDetails?.qcData?.location)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"></path>
                    </svg>
                    QC Scan not confirmed
                  </span>
                </div>
              </div>
              <table class="table table-striped table-bordered qc-table">
                <thead>
                  <tr>
                    <th class="qc-table-flex-column">Label</th>
                    <th class="qc-table-fixed-column">Version</th>
                    <th class="qc-table-fixed-column">Scan Performed</th>
                    <th class="qc-table-fixed-column">Scan Date</th>
                    <th class="qc-table-fixed-column">Scan Error</th>
                    <th class="qc-table-fixed-column">Scan Confirmed</th>
                    <th class="qc-table-flex-column">Errors</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of selectedLocationDetails?.qcData?.location ?? []">
                    <td class="qc-table-flex-column">{{ item.location_information?.label }}</td>
                    <td class="qc-table-fixed-column">{{ item.version }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_performed ? 'Yes' : 'No' }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_date | date : 'short' }}</td>
                    <td class="qc-table-fixed-column">{{ item.qc_scan_error ? 'Yes' : 'No' }}</td>
                    <td class="qc-table-fixed-column">
                      <div class="form-check form-switch qc-confirm-switch" *ngIf="shouldShowQcConfirmToggle(selectedLocationDetails?.qcData?.location, item); else locationScanConfirmedValue">
                        <span class="qc-confirm-switch-label">{{ isQcScanConfirmed(item) ? 'Yes' : 'No' }}</span>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="isQcScanConfirmed(item)"
                          (click)="openConfirmScanModal('Location', 'location', item, !isQcScanConfirmed(item)); $event.preventDefault()"
                        />
                      </div>
                      <ng-template #locationScanConfirmedValue>{{ isQcScanConfirmed(item) ? 'Yes' : 'No' }}</ng-template>
                    </td>
                    <td class="qc-table-flex-column qc-table-errors">
                      <ng-container *ngIf="(item.qc_scan_error_list ?? []).length > 0; else noLocationQcErrors">
                        <div *ngFor="let qcError of item.qc_scan_error_list">{{ qcError.type }} - {{ qcError.message }}</div>
                      </ng-container>
                      <ng-template #noLocationQcErrors>None</ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Hub Configuration -->
  <div *ngIf="selectedLocation && selectedLocation && selectedLocation.hubs && selectedLocation.hubs.length > 0 && selectedHubId !== ''">
    <app-hub-configuration [hubId]="selectedHubId"></app-hub-configuration>
  </div>
</div>

<div class="modal fade" id="confirmQcScanModal" tabindex="-1" aria-labelledby="confirmQcScanModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmQcScanModalLabel">Confirm Scan</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>{{ getQcConfirmModalMessage() }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" [disabled]="isUpdatingQcScanConfirmation" (click)="closeConfirmScanModal()">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="isUpdatingQcScanConfirmation" (click)="onConfirmScanModalYes()">{{ isUpdatingQcScanConfirmation ? 'Saving...' : 'Yes' }}</button>
      </div>
    </div>
  </div>
</div>
